import React from 'react'
import './index.css'

const BaseRadioButton = ({ labelName, onClick, countingMode }) => {
  return (
    <label className={[
      'container-radio',
      countingMode == labelName ? 'active' : '',
    ].join(' ')} onClick={() => onClick(labelName)}>
      <input className='radio--button-input' type='radio' name="gender" />
      <div className='radio--button'></div>
      <span>{labelName}</span>
    </label>
  )
}

export default BaseRadioButton
